export default __webpack_public_path__ + "static/media/cp-report-logo.df86632b.png";